// extracted by mini-css-extract-plugin
export var boxItems = "_76-1";
export var boxItemsLg = "_76-2";
export var button = "_76-7";
export var buttonLg = "_76-8";
export var filterGroupBox = "_76-0";
export var icon = "_76-3";
export var iconSecondary = "_76-6";
export var iconWrapper = "_76-4";
export var iconWrapperLg = "_76-5";